/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  RealtimeConfigResponse,
  UpdateRealtimeConfigBody
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * @summary Gets realtime configuration
 */
export type v1GetRealtimeConfigResponse200 = {
  data: RealtimeConfigResponse
  status: 200
}

export type v1GetRealtimeConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetRealtimeConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetRealtimeConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetRealtimeConfigResponseSuccess = (v1GetRealtimeConfigResponse200) & {
  headers: Headers;
};
export type v1GetRealtimeConfigResponseError = (v1GetRealtimeConfigResponse401 | v1GetRealtimeConfigResponse403 | v1GetRealtimeConfigResponse429) & {
  headers: Headers;
};

export type v1GetRealtimeConfigResponse = (v1GetRealtimeConfigResponseSuccess | v1GetRealtimeConfigResponseError)

export const getV1GetRealtimeConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/realtime`
}

export const v1GetRealtimeConfig = async (ref: string, options?: RequestInit): Promise<v1GetRealtimeConfigResponse> => {
  
  return customFetch<v1GetRealtimeConfigResponse>(getV1GetRealtimeConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Updates realtime configuration
 */
export type v1UpdateRealtimeConfigResponse204 = {
  data: void
  status: 204
}

export type v1UpdateRealtimeConfigResponse401 = {
  data: void
  status: 401
}

export type v1UpdateRealtimeConfigResponse403 = {
  data: void
  status: 403
}

export type v1UpdateRealtimeConfigResponse429 = {
  data: void
  status: 429
}

export type v1UpdateRealtimeConfigResponseSuccess = (v1UpdateRealtimeConfigResponse204) & {
  headers: Headers;
};
export type v1UpdateRealtimeConfigResponseError = (v1UpdateRealtimeConfigResponse401 | v1UpdateRealtimeConfigResponse403 | v1UpdateRealtimeConfigResponse429) & {
  headers: Headers;
};

export type v1UpdateRealtimeConfigResponse = (v1UpdateRealtimeConfigResponseSuccess | v1UpdateRealtimeConfigResponseError)

export const getV1UpdateRealtimeConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/realtime`
}

export const v1UpdateRealtimeConfig = async (ref: string,
    updateRealtimeConfigBody: UpdateRealtimeConfigBody, options?: RequestInit): Promise<v1UpdateRealtimeConfigResponse> => {
  
  return customFetch<v1UpdateRealtimeConfigResponse>(getV1UpdateRealtimeConfigUrl(ref),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateRealtimeConfigBody,)
  }
);}
  

/**
 * @summary Shutdowns realtime connections for a project
 */
export type v1ShutdownRealtimeResponse204 = {
  data: void
  status: 204
}

export type v1ShutdownRealtimeResponse401 = {
  data: void
  status: 401
}

export type v1ShutdownRealtimeResponse403 = {
  data: void
  status: 403
}

export type v1ShutdownRealtimeResponse404 = {
  data: void
  status: 404
}

export type v1ShutdownRealtimeResponse429 = {
  data: void
  status: 429
}

export type v1ShutdownRealtimeResponseSuccess = (v1ShutdownRealtimeResponse204) & {
  headers: Headers;
};
export type v1ShutdownRealtimeResponseError = (v1ShutdownRealtimeResponse401 | v1ShutdownRealtimeResponse403 | v1ShutdownRealtimeResponse404 | v1ShutdownRealtimeResponse429) & {
  headers: Headers;
};

export type v1ShutdownRealtimeResponse = (v1ShutdownRealtimeResponseSuccess | v1ShutdownRealtimeResponseError)

export const getV1ShutdownRealtimeUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/realtime/shutdown`
}

export const v1ShutdownRealtime = async (ref: string, options?: RequestInit): Promise<v1ShutdownRealtimeResponse> => {
  
  return customFetch<v1ShutdownRealtimeResponse>(getV1ShutdownRealtimeUrl(ref),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

